import 'nprogress/nprogress.css'

import { type HOCProps } from './interfaces/common'
import { AppProvider } from './providers/AppProvider'
import Router from './router'
import { useOffline } from './hooks/useOfflineData'

import './styles.scss'

interface AppProps extends HOCProps {}

export const App: React.FunctionComponent<AppProps> = (props) => {
  useOffline()

  return (
    <AppProvider>
      <Router {...props} />
    </AppProvider>
  )
}
